<form [formGroup]="form" (ngSubmit)="save()">
    <div class="tab-card">
        <div class="tab-card-header">
            <span class="tab-icon-badge" style="background:#fdebce;"><img src="assets/img/icons/section-informacion-personal.svg" alt=""></span>
            <h5>Información personal</h5>
        </div>

        <div class="d-flex gap-4 flex-wrap align-items-start">
            <div class="flex-fill" style="min-width: 320px;">
                <div class="field-row">
                    <div class="field-col">
                        <label class="field-label">Nombre(s)</label>
                        <input type="text" class="field-input" formControlName="first_name"
                            [class.is-invalid]="f['first_name'].errors && !f['first_name'].pristine">
                        <div class="invalid-feedback" *ngIf="f['first_name'].errors && !f['first_name'].pristine">
                            El nombre es obligatorio
                        </div>
                    </div>
                    <div class="field-col">
                        <label class="field-label">Apellido paterno</label>
                        <input type="text" class="field-input" formControlName="last_name"
                            [class.is-invalid]="f['last_name'].errors && !f['last_name'].pristine">
                        <div class="invalid-feedback" *ngIf="f['last_name'].errors && !f['last_name'].pristine">
                            El apellido paterno es obligatorio
                        </div>
                    </div>
                </div>
                <div class="field-row">
                    <div class="field-col">
                        <label class="field-label">Apellido materno</label>
                        <input type="text" class="field-input" formControlName="mother_last_name">
                    </div>
                    <div class="field-col">
                        <label class="field-label">Fecha de nacimiento</label>
                        <app-date-picker class="field-input" formControlName="birth_date"></app-date-picker>
                    </div>
                </div>
                <div class="field-row">
                    <div class="field-col">
                        <label class="field-label">Lugar de nacimiento</label>
                        <input type="text" class="field-input" formControlName="birth_place">
                    </div>
                    <div class="field-col">
                        <label class="field-label">Código postal fiscal</label>
                        <input type="text" class="field-input" formControlName="fiscal_zip_code">
                    </div>
                </div>
                <div class="field-row">
                    <div class="field-col">
                        <label class="field-label">IMSS</label>
                        <input type="text" class="field-input" formControlName="nss">
                    </div>
                    <div class="field-col">
                        <label class="field-label">CURP</label>
                        <input type="text" class="field-input" formControlName="curp">
                    </div>
                </div>
                <div class="field-row">
                    <div class="field-col">
                        <label class="field-label">RFC</label>
                        <input type="text" class="field-input" formControlName="rfc">
                    </div>
                    <div class="field-col d-flex flex-column">
                        <label class="field-label" for="rfc_previously_registered_sat">RFC previamente registrado en el SAT</label>
                        <input type="checkbox" id="rfc_previously_registered_sat" formControlName="rfc_previously_registered_sat"
                            style="align-self: flex-start;">
                    </div>
                </div>
            </div>

            <div class="d-flex flex-column gap-3">
                <div class="tab-photo-card">
                    <span class="fw-medium" style="color:#4a5565;">Foto del trabajador</span>
                    <div class="tab-photo-preview">
                        <img *ngIf="photoPreviewUrl" [src]="photoPreviewUrl" alt="Foto del trabajador">
                        <i *ngIf="!photoPreviewUrl" class="ti ti-user"></i>
                    </div>
                    <input type="file" #photoInput class="d-none" accept="image/*" (change)="onFileChange($event)">
                    <a href="javascript:void(0)" class="tab-photo-upload-btn" (click)="photoInput.click()">
                        <i class="ti ti-upload"></i> Cargar fotografía
                    </a>
                </div>

                <div style="width: 240px;">
                    <label class="field-label">Sexo</label>
                    <select class="field-select" formControlName="gender">
                        <option value="">Seleccionar</option>
                        <option value="M">Masculino</option>
                        <option value="F">Femenino</option>
                    </select>
                </div>
            </div>
        </div>
    </div>

    <div class="tab-card">
        <div class="tab-card-header">
            <span class="tab-icon-badge" style="background:#ffccf0;"><img src="assets/img/icons/section-informacion-organizacional.svg" alt=""></span>
            <h5>Información organizacional</h5>
        </div>

        <div class="field-row">
            <div class="field-col">
                <label class="field-label">Departamento</label>
                <select class="field-select" formControlName="department_id" (change)="onDepartmentChange()">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let d of departments" [value]="d.id">{{d.name}}</option>
                </select>
            </div>
            <div class="field-col">
                <label class="field-label">Puesto</label>
                <select class="field-select" formControlName="position_id">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let p of positions" [value]="p.id">{{p.name}}</option>
                </select>
            </div>
        </div>
        <div class="field-row">
            <div class="field-col">
                <label class="field-label">Fecha de alta</label>
                <app-date-picker class="field-input" formControlName="hire_date"
                    [class.is-invalid]="f['hire_date'].errors && !f['hire_date'].pristine"></app-date-picker>
                <div class="invalid-feedback" *ngIf="f['hire_date'].errors && !f['hire_date'].pristine">
                    La fecha de alta es obligatoria
                </div>
            </div>
            <div class="field-col">
                <label class="field-label">Fecha de baja</label>
                <app-date-picker class="field-input" formControlName="termination_date"></app-date-picker>
                <small class="text-muted" *ngIf="employee?.status !== 'terminated'">Se gestiona desde el flujo "Dar de baja"</small>
            </div>
        </div>
        <div class="field-row">
            <div class="field-col">
                <label class="field-label">Modalidad de trabajo</label>
                <select class="field-select" formControlName="work_mode">
                    <option value="">Seleccionar</option>
                    <option value="Presencial">Presencial</option>
                    <option value="Remoto">Remoto</option>
                    <option value="Híbrido">Híbrido</option>
                </select>
            </div>
        </div>
    </div>

    <div class="tab-card">
        <div class="tab-card-header">
            <span class="tab-icon-badge" style="background:#caf4e5;"><img src="assets/img/icons/doc-folder-attachment.svg" alt=""></span>
            <h5>Documentación de contratación</h5>
        </div>

        <div class="doc-info-banner">
            <img src="assets/img/icons/doc-info.svg" alt="">
            <p>Formatos permitidos: <strong>PDF, JPG, PNG</strong> &nbsp;|&nbsp; Tamaño máximo por archivo: <strong>10 MB</strong></p>
        </div>

        <div class="doc-grid">
            <div class="doc-card" *ngFor="let doc of documentTypes">
                <div class="doc-card-head">
                    <span class="doc-icon-badge" [style.background]="doc.iconBg">
                        <img [src]="'assets/img/icons/' + doc.icon" alt="">
                    </span>
                    <div class="doc-card-title">
                        <p class="doc-card-name">{{doc.label}}</p>
                        <p class="doc-card-status" *ngIf="!documentsByType[doc.key] || !doc.required" [class.optional]="!doc.required">
                            {{doc.required ? 'No cargado' : 'Opcional'}}
                        </p>
                    </div>
                </div>

                <label class="doc-dropzone" *ngIf="!documentsByType[doc.key]"
                    [class.doc-dropzone-active]="dragOverKey === doc.key"
                    (dragover)="onDocumentDragOver($event, doc)"
                    (dragleave)="onDocumentDragLeave($event, doc)"
                    (drop)="onDocumentDrop($event, doc)">
                    <input type="file" class="d-none" accept=".pdf,.jpg,.jpeg,.png"
                        (change)="onDocumentFileChange($event, doc)">
                    <img src="assets/img/icons/doc-upload-cloud.svg" alt="">
                    <span class="doc-dropzone-title">Arrastra tu archivo</span>
                    <span class="doc-dropzone-subtitle">o haz clic para buscar</span>
                </label>

                <div class="doc-file-row" *ngIf="documentsByType[doc.key] as file">
                    <img src="assets/img/icons/doc-file-uploaded.svg" alt="" class="doc-file-icon">
                    <span class="doc-file-name" [title]="file.original_name">{{file.original_name}}</span>
                    <a [href]="getDocumentUrl(file)" target="_blank" download class="doc-file-action" title="Descargar">
                        <img src="assets/img/icons/doc-download.svg" alt="">
                    </a>
                    <div class="doc-file-menu" (click)="$event.stopPropagation()">
                        <button type="button" class="doc-file-action doc-file-more-btn" (click)="toggleDocMenu(doc.key)" title="Más opciones">
                            <span class="doc-more-icon"><span></span><span></span><span></span></span>
                        </button>
                        <ul class="dropdown-menu doc-dropdown-menu" [class.show]="openDocMenuKey === doc.key">
                            <li><button class="dropdown-item" type="button" (click)="viewDocument(doc)">Ver archivo</button></li>
                            <li *ngIf="canDo('Eliminar')"><button class="dropdown-item text-danger" type="button" (click)="deleteDocumentFile(doc)">Eliminar archivo</button></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="tab-save-bar" *ngIf="canDo(isCreateMode ? 'Crear' : 'Editar')">
        <button type="submit" class="btn btn-primary">{{isCreateMode ? 'Registrar colaborador' : 'Guardar cambios'}}</button>
    </div>
</form>
